import { withTranslation } from 'react-i18next'
import Templates from './Templates'

export default withTranslation()(Templates)
